/**
 * @description Returns true if the filterType parameter is valid and should display as a
 * chip on the filter page, false otherwise.
 *
 * @param {string} filterType   A filter type
 *
 * @returns {boolean} True if filterType is a valid filter and should be displayed as
 * a chip, false otherwise
 */
export const showFilterChip = (filterType) => {
  const filterTypes = {
    make: true,
    model: true,
    bodyType: true,
    condition: true,
    price: true,
    kilometers: true,
    year: true,
    exteriorColour: true,
    interiorColour: true,
    transmission: true,
    fuelType: true,
    driveType: true,
    lifestyle: true,
    dealershipId: false,
    sellerType: true,
  };

  return filterTypes[filterType] ? filterTypes[filterType] : false;
};
